import Swiper from "swiper";
import { Navigation, A11y, Keyboard, EffectFade } from "swiper/modules";

export const init = function () {
  let imageGalleries = document.querySelectorAll(".image-gallery-box");

  imageGalleries.forEach((imageGallery) => {
    let id = imageGallery.querySelector(".swiper.image-gallery-slider").id;

    let igSlider = new Swiper("#" + id, {
      modules: [Navigation, Keyboard, A11y, EffectFade],
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      keyboard: { enabled: true },
      a11y: { enabled: true },
      on: {
        afterInit: function (swiper) {
          let slides = swiper.slides;
          slides.forEach((slide, index) => {
            let slidePage = slide.querySelector(".pages");
            slidePage.innerHTML = `${index + 1}/${slides.length}`;
          });

          imageGallery.classList.add("slider-init");
        },
      },
    });
  });
};
